import { useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import {
  Tree,
  getBackendOptions,
  MultiBackend,
} from "@minoru/react-dnd-treeview";
import { DndProvider } from "react-dnd";
import { configMenuSelector } from "../../../services/selector/index.";
import BaseButton from "../Button/BaseButton";
import { Col, Row } from "antd";
import TranslateText from "../TranslateText";
import SelectValue from "../Selector/SelectValue";
import { Placeholder } from "../NodeMenu/Placeholder";
import { CustomDragPreview } from "../NodeMenu/CustomDragPreview";
import { CustomNode } from "../NodeMenu/CustomNode";
import "../../../assets/style/featuresStyle/menuConfig.scss";
import { useDispatch } from "react-redux";
import {
  getMenuWithType,
  saveConfig,
  saveConfigAdmin,
  setValueSelect,
} from "../../../services/slice/ConfigMenuSlice";
import { valueSelectLicense } from "../../../utils/ValueSelect";
import { IconSave } from "../../../assets/icon";
const SetUpMemnu = ({ type, setType }) => {
  const menuState = useSelector(configMenuSelector);
  const [treeData, setTreeData] = useState([]);
  const { menuValueSelect } = menuState;
  const dispatch = useDispatch();

  const handleDrop = (newTree) => {
    setTreeData(newTree);
  };
  const dataTree = useMemo(() => {
    const result = [];
    // eslint-disable-next-line array-callback-return
    menuState?.dataMenuWithType.map((value) => {
      if (value.type === 0) {
        result.push({
          id: value.id,
          icon: value.icon,
          parent: 0,
          droppable: true,
          text: value.nameVn,
          hasChild: value.child.length ? true : false,
          data: {
            fileType: "text",
          },
        });
      } else {
        result.push({
          id: value.id,
          parent: 0,
          droppable: true,
          hasChild: value.child.length ? true : false,
          text: value.nameVn,
          data: {
            fileType: "text",
          },
        });
        value.child.map((item) =>
          result.push({
            id: item.id,
            parent: value.id,
            droppable: true,
            text: item.nameVn,
            data: {
              fileType: "text",
            },
          })
        );
      }
    });
    return result;
  }, [menuState?.dataMenuWithType]);

  useEffect(() => {
    const filteredArr = menuValueSelect.filter(
      (item) => treeData.findIndex((element) => element.id === item.id) === -1
    );
    setTreeData((pre) => [...pre, ...filteredArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuValueSelect]);
  useEffect(() => {
    if (dataTree) setTreeData(dataTree);
  }, [dataTree, dataTree.length]);

  const submitSaveConfigMenu = () => {
    let ArrayMenu = [];
    if (!treeData) return;
    treeData.forEach((item, index) => {
      ArrayMenu.push({
        id: item.id,
        location: index + 1,
        menuID: item.parent,
      });
    });
    if (!type) return dispatch(saveConfig(ArrayMenu));
    else {
      return dispatch(
        saveConfigAdmin({ typeAdmin: type, listMenuConfig: ArrayMenu })
      );
    }
  };
  useEffect(() => {
    dispatch(getMenuWithType(type));
  }, [dispatch, menuState.refetch, type]);

  const handleChangeLicense = (value) => {
    setType(value);
  };
  return (
    <div className="wrapperSetUpMenu">
      <Row className="headerSetupMenu" justify={"space-between"} align="middle">
        <Col span={8}>
          <span className="title">
            <TranslateText text={"Cấu hình Menu"} />
          </span>
        </Col>
        <Col span={16}>
          {type ? (
            <SelectValue
              type={"selectGray"}
              handleChange={handleChangeLicense}
              optionsValue={valueSelectLicense}
              defaultValue={"Supper Admin"}
              width={185}
            />
          ) : null}
        </Col>
      </Row>
      <Row className="bodySetupMenu">
        {treeData.length ? (
          <>
            <p className="guide">
              <TranslateText
                text={"Kéo thả từng mục theo thứ tự bạn muốn sắp xếp:"}
              />
            </p>
            <DndProvider backend={MultiBackend} options={getBackendOptions()}>
              <div className={"wrapperTree"}>
                <Tree
                  tree={treeData}
                  rootId={0}
                  render={(node, { depth, isOpen, onToggle, hasChild }) => (
                    <CustomNode
                      deleteItem={(value) => {
                        setTreeData(
                          treeData.filter((item) => item.id !== value)
                        );
                      }}
                      node={node}
                      depth={depth}
                      onToggle={onToggle}
                      isOpen={isOpen}
                      hasChild={hasChild}
                    />
                  )}
                  dragPreviewRender={(monitorProps) => (
                    <CustomDragPreview monitorProps={monitorProps} />
                  )}
                  onDrop={handleDrop}
                  classes={{
                    root: "treeRoot",
                    draggingSource: "draggingSource",
                    placeholder: "placeholderContainer",
                  }}
                  sort={false}
                  insertDroppableFirst={false}
                  canDrop={(tree, { dragSource, dropTargetId, dropTarget }) => {
                    if (dragSource?.parent === dropTargetId) {
                      return true;
                    }
                  }}
                  dropTargetOffset={5}
                  placeholderRender={(node, { depth }) => (
                    <Placeholder node={node} depth={depth} />
                  )}
                />
              </div>
            </DndProvider>
            {/* <DndProvider backend={MultiBackend} options={getBackendOptions()}>
              <div className={"wrapperTree"}>
                <Tree
                  tree={treeData}
                  rootId={0}
                  render={(node, { depth }) => (
                    <React.Fragment>
                      {renderTreeNodes([node], depth)}
                    </React.Fragment>
                  )}
                />
              </div>
            </DndProvider> */}
          </>
        ) : (
          <p className="guide">
            <TranslateText text={"Thêm các mục menu từ cột bên trái"} />
          </p>
        )}
      </Row>
      <Row className="footerSetupMenu">
        <BaseButton
          handleClick={submitSaveConfigMenu}
          content={"Lưu"}
          typeBtn="btnOrange"
          icon={<IconSave />}
          width={100}
        />
      </Row>
    </div>
  );
};

export default SetUpMemnu;
